import axios from 'axios'
import appConfig from '@/config/app-config'

const videoClient = axios.create({
  baseURL: `${appConfig.video.apiBase}/api/video`,
  timeout: 30000
})

export function getBridges() {
  return videoClient.get('/bridges').then(r => r.data)
}

export function getChannels(params) {
  return videoClient.get('/channels', { params }).then(r => r.data)
}

export function ensureStream(nvrId, channel) {
  return videoClient.get(`/ready/${nvrId}/${channel}`, { validateStatus: () => true }).then(r => r.data)
}

export function releaseStream(nvrId, channel) {
  return videoClient.get(`/release/${nvrId}/${channel}`, { validateStatus: () => true }).then(r => r.data)
}

export function listNvr() {
  return videoClient.get('/nvr').then(r => r.data)
}

export function getPresets(nvrId, channel) {
  return videoClient.get(`/nvr/${nvrId}/ptz/${channel}/presets`).then(r => r.data)
}

export function getPtzCapability(nvrId, channel) {
  return videoClient.get(`/nvr/${nvrId}/ptz/${channel}/capability`, { validateStatus: () => true }).then(r => r.data)
}

export function ptzContinuous(nvrId, channel, params) {
  return videoClient.put(`/nvr/${nvrId}/ptz/${channel}/continuous`, params).then(r => r.data)
}

export function ptzStop(nvrId, channel) {
  return ptzContinuous(nvrId, channel, { pan: 0, tilt: 0, zoom: 0 })
}

export function gotoPreset(nvrId, channel, preset) {
  return videoClient.put(`/nvr/${nvrId}/ptz/${channel}/presets/${preset}/goto`).then(r => r.data)
}

export function snapshotUrl(nvrId, channel) {
  return `${appConfig.video.apiBase}/api/video/nvr/${nvrId}/snapshot/${channel}?t=${Date.now()}`
}

const cfgClient = axios.create({
  baseURL: `${appConfig.video.apiBase}/api/video-config`,
  timeout: 30000
})

export function cfgListNvr(params) {
  return cfgClient.get('/nvr', { params }).then(r => r.data)
}

export function cfgCreateNvr(body) {
  return cfgClient.post('/nvr', body).then(r => r.data)
}

export function cfgUpdateNvr(id, body) {
  return cfgClient.put(`/nvr/${id}`, body).then(r => r.data)
}

export function cfgDeleteNvr(id) {
  return cfgClient.delete(`/nvr/${id}`).then(r => r.data)
}

export function cfgNvrSecret(id) {
  return cfgClient.get(`/nvr/${id}/secret`).then(r => r.data)
}

export function cfgTestNvr(id) {
  return cfgClient.post(`/nvr/${id}/test`).then(r => r.data)
}

export function cfgSyncChannels(id) {
  return cfgClient.post(`/nvr/${id}/sync-channels`).then(r => r.data)
}

export function cfgListChannels(params) {
  return cfgClient.get('/channel', { params }).then(r => r.data)
}

export function cfgUpdateChannel(id, body) {
  return cfgClient.put(`/channel/${id}`, body).then(r => r.data)
}

export function cfgAudit(params) {
  return cfgClient.get('/audit', { params }).then(r => r.data)
}

export function cfgReload() {
  return cfgClient.post('/reload').then(r => r.data)
}

export default {
  getBridges,
  getChannels,
  ensureStream,
  releaseStream,
  listNvr,
  getPresets,
  ptzContinuous,
  getPtzCapability,
  ptzStop,
  gotoPreset,
  snapshotUrl,
  cfgListNvr,
  cfgCreateNvr,
  cfgUpdateNvr,
  cfgDeleteNvr,
  cfgNvrSecret,
  cfgTestNvr,
  cfgSyncChannels,
  cfgListChannels,
  cfgUpdateChannel,
  cfgAudit,
  cfgReload
}
